export default __webpack_public_path__ + "static/media/lady-right-01.9c4d2792.png";